export const delayPromise = (ms: number = 1000) =>
  new Promise((_) => setTimeout(_, ms));
